import { render, staticRenderFns } from "./AccountantsCustomersMenu.vue?vue&type=template&id=66fd8a7c&scoped=true&"
import script from "./AccountantsCustomersMenu.vue?vue&type=script&lang=js&"
export * from "./AccountantsCustomersMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fd8a7c",
  null
  
)

export default component.exports